import styled from 'styled-components';
import {
  IconButton as MUIIconButton,
  Grid,
  Button,
  Box,
} from '@material-ui/core';

import { NumberOfActiveFilters as CPNumberOfActiveFilters } from '@keaze/web/components/filters/numberOfActiveFilters';

export const IconButton = styled(MUIIconButton)`
  width:35%;
  height: 35px;
  margin:0 5px;
  border: 1px solid white;
  border-radius: 5px;
`;

export const IconXButton = styled(MUIIconButton)`
  padding: 0;
  height: 35px;
  ${({
    theme: {
      colors
    },
  }) => `
  svg {width: 40px; height: 40px;}
  path {fill: ${colors.whites.white1} }
  `}
`;

export const Header = styled(Grid)`
margin-bottom: 20px;
`;

export const ShowListingsButton = styled(Button)`
${({
  theme: {
    colors
  },
}) => `
background-color: ${colors.golds.gold1};
width:80%;
color:  ${colors.browns.brown1};
margin: 0 auto;
font-size: 18px;
border-radius: 25px !important;

`}

`;

export const NumberOfActiveFilters = styled(CPNumberOfActiveFilters)`
  position: absolute;
  top: 0;
  right: -10px;
`;

export const ClearAllButtonWrapper = styled(Box)`

`;

export const ClearAllButton = styled(Button)`
  ${({
    theme: {
      typography: { body2 },
    },
  }) => `
    font-size: ${body2.fontSize};
    line-height: ${body2.lineHeight};
    font-weight: ${body2.fontWeight};
  `}
`;
